<template>
  <div :class="b()">
    <ul
      :class="b('list')"
      role="list"
    >
      <li
        v-for="(item, index) in items"
        :key="`link-item--${index}`"
        :class="b('item')"
        role="listitem"
      >
        <e-picture
          v-if="item.image"
          :class="b('item-image')"
          :srcset="item.image.srcset"
          :alt="item.image.alt"
          :title="item.image.title"
          :fallback="item.image.fallback"
          :ratio="3 / 2"
          :sizes="pictureSizes"
          loading="lazy"
        />
        <div :class="b('wrapper')">
          <p :class="b('item-title')">
            {{ item.label }}
          </p>
          <p :class="b('item-description')">
            {{ item.description }}
          </p>
        </div>
        <a
          :class="b('item-link')"
          :href="item.url"
          download
          target="_blank"
          rel="noopener noreferrer"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import ePicture from '@/elements/e-picture.vue';
  import { CustomLink } from '@/types/product';
  import { ImageSizes } from '@/types/sizes';

  // type Setup = {};

  type Data = {
    pictureSizes: ImageSizes;
  };

  /**
   * Renders a list of download links.
   */
  export default defineComponent({
    name: 'c-link-list',

    components: {
      ePicture,
    },

    props: {
      /**
       * Items to be displayed.
       */
      items: {
        type: Array as PropType<CustomLink[]>,
        default: () => [],
      },
    },
    // emits: {},

    // setup(): Setup {
    //   return {};
    // },
    data(): Data {
      return {
        pictureSizes: {
          xxs: 210,
          xs: 356,
          sm: 316,
          md: 280,
          lg: 376,
          fallback: 376,
        },
      };
    },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use 'sass:map';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';

  .c-link-list {
    $this: &;

    $content-padding: 1rem;
    $content-line-height: 1.15;

    #{$this}__list {
      --max-items: 2;

      display: grid;
      gap: 1.5rem;
      grid-template-columns: repeat(
        auto-fit,
        calc(100% / var(--max-items) - (1.5rem * (var(--max-items) - 1) / var(--max-items)))
      );
      padding: 0.5rem;

      @include mixins.media(sm) {
        --max-items: 4;
      }

      @include mixins.media(md) {
        --max-items: 5;
      }

      @include mixins.media(lg) {
        --max-items: 6;
      }
    }

    #{$this}__item {
      @include mixins.hover-effect--default();

      position: relative;
      height: 100%;
      min-height: 10rem;
      display: flex;
      flex-direction: column;
      background-color: variables.$va-color-grayscale--900;
      overflow-wrap: break-word;
      box-shadow: 0 -8px 50px -10px rgba(229, 229, 229, 80%);

      @include mixins.media(sm) {
        min-height: 15rem;
      }
    }

    #{$this}__item-image {
      margin-bottom: $content-padding;
    }

    #{$this}__wrapper {
      padding: 0 $content-padding;
    }

    #{$this}__item-title {
      @include mixins.line-clamp(4, $content-line-height);

      font-weight: variables.$va-font-weight--bold;
      line-height: $content-line-height;
      margin-bottom: 0.5rem;
    }

    #{$this}__item-description {
      @include mixins.line-clamp(6, $content-line-height);

      line-height: $content-line-height;
      margin-bottom: 0.5rem;
    }

    #{$this}__item-link {
      display: flex;
      align-items: center;
      place-self: flex-end;
      margin: auto $content-padding $content-padding;
      gap: 0.5rem;
      padding: 3px;
      font-size: variables.$font-size--small;

      @include mixins.media(sm) {
        font-size: variables.$font-size--regular;
      }

      &::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
</style>
